export enum CoreDialogApiTags {
  DialogList = 'DialogList',
  Dialog = 'Dialog',
  Messages = 'Messages',
  UnreadMessagesCount = 'UnreadMessagesCount',
}

export const coreDialogApiTagTypes = Object.values(CoreDialogApiTags);
